import { Tab, Tabs, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import InviteStudentsContainer from './InviteStudentsContainer';
import { useMsTeams } from '../../providers/MsTeamsContext';

const StyledTabs = styled(Tabs)`
    margin-bottom: 24px;
`;

const StyledTab = styled(Tab)`
    font-size: 15px;
    text-transform: none;
`;

const InviteStudentsNav = () => {
    const { activeTab, setActiveTab, errorIndexes } = useContainer(InviteStudentsContainer);
    const { t } = useTranslation('invite_students', { useSuspense: false });
    const { msToken } = useMsTeams();

    return (
        <StyledTabs
            value={activeTab}
            onChange={(_event, value) => setActiveTab(value)}
            orientation="horizontal"
            indicatorColor="primary"
            textColor="primary"
        >
            <StyledTab value="simple" label={t('navigation.simple')} />
            <StyledTab value="advanced" label={t('navigation.advanced')} />
            <StyledTab value="bulkImport" label={t('navigation.bulk-import')} />
            {!!msToken && <StyledTab value="msTeams" label={t('navigation.ms-teams')} />}

            {(errorIndexes.length > 0 || activeTab === 'error') && (
                <StyledTab value="error" label={t('navigation.error')} />
            )}
        </StyledTabs>
    );
};

export default InviteStudentsNav;
